export default "__VITE_ASSET__822bcc0e__$_#icon-close__"